import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
function Counter({
  end,
  suffix = '',
  duration = 2000
}: {
  end: number;
  suffix?: string;
  duration?: number;
}) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  useEffect(() => {
    if (isInView) {
      let start = 0;
      const increment = end / (duration / 16);
      const timer = setInterval(() => {
        start += increment;
        if (start >= end) {
          setCount(end);
          clearInterval(timer);
        } else {
          setCount(Math.floor(start));
        }
      }, 16);
      return () => clearInterval(timer);
    }
  }, [isInView, end, duration]);
  return <span ref={ref} data-id="element-302">
      {count.toLocaleString()}
      {suffix}
    </span>;
}
export function StatsStrip() {
  const stats = [{
    value: 33,
    suffix: '+',
    label: 'Years Experience'
  }, {
    value: 10000,
    suffix: '+',
    label: 'Jobs Completed'
  }, {
    value: 24,
    suffix: '/7',
    label: 'Emergency Service'
  }, {
    value: 5,
    suffix: '★',
    label: 'Customer Rated'
  }];
  return <section className="bg-brand-gray py-12 border-b border-gray-200" data-id="element-303">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-304">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 divide-x-0 md:divide-x divide-gray-300" data-id="element-305">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="text-center px-4" data-id="element-306">
              <div className="text-4xl md:text-5xl font-display font-bold text-brand-navy mb-2" data-id="element-307">
                <Counter end={stat.value} suffix={stat.suffix} data-id="element-308" />
              </div>
              <div className="text-sm font-bold text-gray-600 uppercase tracking-wider" data-id="element-309">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}